import React from "react";
import { withRouter } from "react-router-dom";
import { compose } from 'redux';
import { withStyles } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';

import withCurrentUser from "../../../hocs/with_current_user.js.jsx";
import withShowToast from '../../../hocs/with_show_toast.js.jsx';

import WebRoutes from "../../routes.js.jsx";

import Container from "../../../base/components/container.js.jsx";

import styles from "./styles.js.jsx";

import ConfirmInvestmentUseCase from "../../../use_cases/projects/investments/confirm_investment_use_case.js.jsx";

import { NotFoundErrorCode } from "../../../constants.js.jsx";

class ConfirmInvest extends React.Component {

  componentDidMount() {
    const { identifier } = this.props;
    if (!identifier) {
      return;
    }
    ConfirmInvestmentUseCase.execute(identifier)
      .then((result) => {
        const { history } = this.props;
        const { data: { investment: { project: { slug } } } } = result;
        history.replace(WebRoutes.invest(slug));
      })
      .catch((result) => {
        const { history } = this.props;
        const { errorCode } = result;
        if (errorCode === NotFoundErrorCode) {
          history.replace(WebRoutes.pageNotFound());
          return;
        }
        this.props.showServerErrorIfNeed(result);
      })
  }

  render() {
    const { classes } = this.props;

    return <div className={classes.root} >
      <Container className={classes.container} >
        <CircularProgress className={classes.loader} />
      </Container>
    </div>
  }
}

export default compose(
  withRouter,
  withShowToast,
  withCurrentUser,
  withStyles(styles)
)(ConfirmInvest);
